export const FETCH_PAYOUTS = "FETCH_PAYOUTS";
export const LOAD_MORE_PAYOUTS = "LOAD_MORE_PAYOUTS";
